import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET LEDGER REPORT START *********************** */
export const LedgerReportsListGet = (listData: any) => {
	const data = {
		GetLedgerReportsToken: listData,
	};
	const url = `${FIN_API_URL}getLedgerReports`;
	return makeApiCall(url, data);
};
/** ***************** GET LEDGER REPORT START *********************** */

/** ***************** GET ACCOUNT HEAD START *********************** */
export const AccountHeadGet = (listData: any) => {
	const data = {
		GetAccountListToken: listData,
	};
	const url = `${FIN_API_URL}getAccountHead`;
	return makeApiCall(url, data);
};
/** ***************** GET ACCOUNT HEAD END *********************** */
